import React from 'react';
import MonthlyRankingItem from './MonthlyRankingItem';

const MonthlyRankingSection = ({ title = '랭킹', monthLabel, entries, onOpenAll, onOpenUser }) => {
  return (
    <div className="bg-card rounded-lg shadow-gaming-md p-6 md:p-8 border border-border flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground">{title}</h2>
        <button
          type="button"
          onClick={onOpenAll}
          className="px-3 py-2 rounded-md bg-muted/40 text-foreground hover:bg-muted transition-gaming"
        >
          전체 보기
        </button>
      </div>
      <div className="flex items-center justify-between mb-3">
        <div className="text-sm md:text-base font-heading font-semibold text-foreground">이번 달 TOP 5</div>
        <span className="text-xs text-muted-foreground caption">{monthLabel}</span>
      </div>

      {entries.length === 0 ? (
        <p className="text-sm text-muted-foreground caption">랭킹 데이터가 없습니다.</p>
      ) : (
        <div className="space-y-2 flex-1">
          {entries.map((entry, index) => (
            <MonthlyRankingItem
              key={entry.user_id}
              entry={entry}
              index={index}
              onClick={() => onOpenUser(entry.user_id)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default MonthlyRankingSection;
